window.$ = window.jQuery = require('jquery');
require('./bootstrap');
//require('./blockcms');
require('./plugins/jquery-easing/jquery.easing.min.js');
require('./plugins/parallax.js');
require('./plugins/slick.js');
require('./plugins/morphext.js');
require('./plugins/clamp.js');
require('./plugins/smartWebBanner/jQuery.smartWebBanner.js');
//require('../../../vendor/whyce/socialshare/src/resources/assets/app.js');
var WOW = require('./plugins/wow.js');
require('./blockcms.js');
window.site = {
 init: function() {
   //this.headerSmall = false;
   this.handlers();
   this.carousel();
   this.clamp();
   this.slideMoreInfo();
   this.ajaxForms();
   // $(window).scroll(function() {
   //   window.site.fixed();
   // });
   var _wow = new WOW({
     mobile: false
   });
   _wow.init();
},

//Voor clamp.js ondersteuning
slideMoreInfo: function() {
    $('.more-slide-info').bind('click',function() {
      $('.slide-info').addClass('hidden');
      $('.more-info-active').removeClass('more-info-active');
      $($(this).attr('href')).removeClass('hidden');
      $('a[href="' + $(this).attr('href') + '"]').parents('.slick-slide').find('.slide').addClass('more-info-active');
    });
    $(".slider").on("afterChange", function (){
      if($('a[href="#'+ $('.slide-info').not('.hidden').first().attr('id')+'"]').parents('.slick-slide.slick-active').length==0) {
        // Slide not longer visible, switch to first available
        var firstAvailable = $('.slick-slide.slick-active').first().find('a.more-slide-info').attr('href');
        $('.slide-info').addClass('hidden');
          $(firstAvailable).removeClass('hidden');
          $('.more-info-active').removeClass('more-info-active');
          $('a[href="' + firstAvailable + '"]').parents('.slick-slide').find('.slide').addClass('more-info-active');
      }
    });

},
isIE: function() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
          // IE 11 => return version number
          var rv = ua.indexOf('rv:');
          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }


        // other browser
        return false;
  },
  //Voor clamp.js ondersteuning
  isIEorEdge: function() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
          // IE 11 => return version number
          var rv = ua.indexOf('rv:');
          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
          // Edge (IE 12+) => return version number
          return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
  },
  clamp: function() {


      var isFirefox = $('body').hasClass('firefox');

      $('.clamp').each(function(index, element) {
          var clampMethod = $(element).data('clamp');
          if((window.site.isIE() || isFirefox) && window.site.isInt(clampMethod)) {
             clampMethod++;
          }
          $clamp(element, { clamp: clampMethod, useNativeClamp: true });
      });

  },
  ajaxForms: function() {

  	$('form[data-ajaxform]').find('.form-group[data-showwhen]').each(function(s,e) {
  		var _showwhen = $(this).data('showwhen').split('=');
  		var elm = _showwhen[0];
  		var requirement = _showwhen[1];
  		var $target = $('[name="' + elm + '"]');
  		if($target) {

  			var toggleTarget = $('.form-group[data-showwhen="'+$(this).data('showwhen')+'"]');
  			if(requirement=='checked') {
  				if($target.is(':checked')) {
  					$(toggleTarget).removeClass('hidden');
  				} else {
  					$(toggleTarget).addClass('hidden');
  				}
  				$target.data('showwhentarget',toggleTarget);
  				$target.unbind('change').bind('change',function() {
  					$($(this).data('showwhentarget')).toggleClass('hidden');
  				});
  			}
  			if(requirement=='unchecked') {
  				if(!$target.is(':checked')) {
  					$(toggleTarget).removeClass('hidden');
  				} else {
  					$(toggleTarget).addClass('hidden');
  				}
  				$target.data('showwhentarget',toggleTarget);
  				$target.unbind('change').bind('change',function() {
  					$($(this).data('showwhentarget')).toggleClass('hidden');
  				});
  			}
  		}

  	});

  	$('form[data-ajaxform]').bind('submit',function(event) {
  		event.preventDefault();
  		$form = $(this);
  		$response = $('#'+$(this).attr('id')+'-response');

      $form.find('.form-group').addClass('hidden');
      $form.find('.hide-after-submit').addClass('hidden');
  		$form.find('.busy').removeClass('hidden');
  		var form_data = new FormData($(this)[0]);

  		$.ajax({
  			type:'POST',
  			url:$(this).attr('action'),
  			processData: false,
  			contentType: false,
  			cache: false,
  			data : form_data,
  			success: function(response){
  				$form.find('.busy').addClass('hidden');
  				$form.find('.hide-after-submit').addClass('hidden');
  				$response.removeClass('hidden');
  			}
  		});


  		return false;
  	}).removeAttr('data-ajaxform');

  },
handlers: function() {

  "use strict"; // Start of use strict

  $('.webshop-button').bind('click',function() {
    if($('.webshop-login-hidden').length==1) {
      $('.webshop-login-hidden').addClass('webshop-login-visible').removeClass('webshop-login-hidden');
      $('body').addClass('webshop-login-open').removeClass('webshop-login-closed');
      $(".webshop-button .icon-down-open-3").removeClass("d-inline");
      $(".webshop-button .icon-down-open-3").addClass("d-none");
      $(".webshop-button .icon-up-open-3").removeClass("d-none");
      $(".webshop-button .icon-up-open-3").addClass("d-inline");
      $(".webshop-button").addClass('toggled');
    } else if($('.webshop-login-visible').length==1) {
      $('.webshop-login-visible').removeClass('webshop-login-visible').addClass('webshop-login-hidden');
      $('body').addClass('webshop-login-closed').removeClass('webshop-login-open');
      $(".webshop-button .icon-down-open-3").removeClass("d-none");
      $(".webshop-button .icon-down-open-3").addClass("d-inline");
      $(".webshop-button .icon-up-open-3").removeClass("d-inline");
      $(".webshop-button .icon-up-open-3").addClass("d-none");
      $(".webshop-button").removeClass('toggled');
    }
  });

  $('.clickable-block').unbind('click').bind('click',function() {
      window.location = $(this).find('a.more-slide-info').first().attr('href');
  });

  if(typeof(autoOpen)!=='undefined') {
    $('.webshop-button').trigger('click');
  }
  $('.card-info iframe').each(function(a,b) {
    if($(b).parents('div.videoWrapper').length==0) {
      $(b).wrap('<div class="videoWrapper"></div>');
    }
  });

  // Smooth scrolling using jQuery easing
  $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: (target.offset().top - 120)
        }, 1000, "easeInOutExpo");
        return false;
      }
    }
  });

  // Closes responsive menu when a scroll trigger link is clicked
  $('.js-scroll-trigger').click(function() {
    $('.navbar-collapse').collapse('hide');
  });

  // Activate scrollspy to add active class to navbar items on scroll
  $('body').scrollspy({
    target: '#mainNav',
    offset: 160
  });

  // Collapse Navbar
  var navbarCollapse = function() {
    if ($("#mainNav").offset().top > 100) {
      $("#mainNav").addClass("navbar-shrink");
      $("body").addClass("scrolled");
    } else {
      $("#mainNav").removeClass("navbar-shrink");
      $("body").removeClass("scrolled");
    }
  };
  // Collapse now if page is not at top
  navbarCollapse();
  // Collapse the navbar when page is scrolled


  //Verberg navbar in 1e pagina/splash page
  //Toon taalswitch
  $(window).scroll(navbarCollapse);

  $("#js-rotating").Morphext({
      // The [in] animation type. Refer to Animate.css for a list of available animations.
      animation: "bounceIn",
      // An array of phrases to rotate are created based on this separator. Change it if you wish to separate the phrases differently (e.g. So Simple | Very Doge | Much Wow | Such Cool).
      separator: ",",
      // The delay between the changing of each phrase in milliseconds.
      speed: 2000,
      complete: function () {
          // Called after the entrance animation is executed.
      }
  });

  $( ".section-sub-title" ).wrapInner( "<span></span>");

  $(".partner-container .toggle-collapse").click(function (e) {
      e.preventDefault();
      $(".partner-container").removeClass("expanded");
      $(this).parents('.partner-container').first().addClass('expanded');
  });

  $().smartWebBanner({
          title: 'Nagel website', // What the title of the "app" should be in the banner
          titleSwap: true, // Whether or not to use the title specified here as the default label of the home screen icon (otherwise uses the page's "apple-mobile-web-app-title" meta tag or <title> tag as a fallback)
          url: '/', // URL to mask the page as before saving to home screen (allows for having it save the homepage of a site no matter what page the visitor is on)
          author: 'Save to Home Screen', // What the author of the "app" should be in the banner
          speedIn: 300, // Show animation speed of the banner
          speedOut: 400, // Close animation speed of the banner
          useIcon: true, // Whether or not it should show site's apple touch icon (located via <link> tag)
          iconOverwrite: '', // Force the URL of the icon (even if found via <link> tag)
          iconGloss: false, // Whether or not to show the gloss over the icon (true/false/"auto" [auto doesn't show if precomposed <link> tag is used])
          showFree: true, // Whether or not to show "Free" at bottom of info
          daysHidden: 21, // Duration to hide the banner after being closed (0 = always show banner)
          daysReminder: 500, // Duration to hide the banner after "Save" is clicked *separate from when the close button is clicked* (0 = always show banner)
          popupDuration: 4000, // How long the instructions are shown before fading out (0 = show until manually closed)
          popupSpeedIn: 200, // Show animation speed of the popup
          popupSpeedOut: 500, // Close animation speed of the popup
          theme: 'iOS 7', // Change between "auto" (detect iOS version), "iOS 6", "iOS 7", and "dark" theme to fit your site design & visitors
          autoApp: false, // Whether or not it should auto-add the mobile-web-app meta tag that makes it open as an app rather than in mobile safari
          debug: false // Whether or not it should always be shown (even for non-iOS devices & if cookies have previously been set) *This is helpful for testing and/or previewing
  });
},

carousel: function() {
  $('.customer-logos').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: false,
        infinite: true,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
                slidesToShow: 3
            }
          },
          {
            breakpoint: 820,
            settings: {
                slidesToShow: 2
            }
          }
      ]
    });

  $('.carousel.slide').carousel({
    interval: 9000,
    pause: "hover"
  });
}
}

$(function() {
 window.site.init();
});

document.addEventListener("DOMContentLoaded",
        function() {

            var div, n,
                v = document.getElementsByClassName("youtube-player");

            for (n = 0; n < v.length; n++) {
                if(cookieConsent=='agreed') {
                  div = document.createElement("div");
                  div.setAttribute("data-id", v[n].dataset.id);
                  div.innerHTML = labnolThumb(v[n].dataset.id);
                  div.onclick = labnolIframe;
                  v[n].appendChild(div);
                }

            }
        });

    function labnolThumb(id) {
        var thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg">',
            play = '<div class="play"></div>';
        return thumb.replace("ID", id) + play;
    }

    function labnolIframe() {
        var iframe = document.createElement("iframe");
        var embed = "https://www.youtube.com/embed/ID?autoplay=1";
        iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "1");
        this.parentNode.replaceChild(iframe, this);
    }



// WEBPACK FOOTER //
// ./resources/assets/js/site.js